/**
 * Products for /upgrade-checkout/:productAlias
 * productId = content after "https://spiking.com/purchase/"
 * Source: Left Menu WMS 2022-2026 - 2026 Final.pdf
 */
export const UPGRADE_CHECKOUT_PRODUCTS = {
  pro: {
    productName: "Pro",
    monthlyProductId: "pro",
    yearlyProductId: "spikingpro",
    monthlyLabel: "$29 (1st month), then $299/year",
    yearlyLabel: "$299/year +",
    yearlyHighlightText: "1 month free",
    description:
      "Introductory offer for new subscribers only. $29 charged immediately for a 1-month paid trial. After your 1-month paid trial, $299 will be charged automatically for an annual subscription unless you cancel during your 1-month trial. Auto-renews as an annual subscription at the then current annual list price (current list price is $299/year).",
  },
  "daily-bread": {
    productName: "Daily Bread",
    monthlyProductId: "pro",
    yearlyProductId: "spikingpro",
    monthlyLabel: "$29 (1st month), then $299/year",
    yearlyLabel: "$299/year +",
    yearlyHighlightText: "1 month free",
    description:
      "Introductory offer for new subscribers only. $29 charged immediately for a 1-month paid trial. After your 1-month paid trial, $299 will be charged automatically for an annual subscription unless you cancel during your 1-month trial. Auto-renews as an annual subscription at the then current annual list price (current list price is $299/year).",
  },
  resurrection: {
    productName: "Resurrection",
    monthlyProductId: "pro",
    yearlyProductId: "spikingpro",
    monthlyLabel: "$29 (1st month), then $299/year",
    yearlyLabel: "$299/year +",
    yearlyHighlightText: "1 month free",
    description:
      "Introductory offer for new subscribers only. $29 charged immediately for a 1-month paid trial. After your 1-month paid trial, $299 will be charged automatically for an annual subscription unless you cancel during your 1-month trial. Auto-renews as an annual subscription at the then current annual list price (current list price is $299/year).",
  },
  triangulation: {
    productName: "Triangulation",
    monthlyProductId: "pro",
    yearlyProductId: "spikingpro",
    monthlyLabel: "$29 (1st month), then $299/year",
    yearlyLabel: "$299/year +",
    yearlyHighlightText: "1 month free",
    description:
      "Introductory offer for new subscribers only. $29 charged immediately for a 1-month paid trial. After your 1-month paid trial, $299 will be charged automatically for an annual subscription unless you cancel during your 1-month trial. Auto-renews as an annual subscription at the then current annual list price (current list price is $299/year).",
  },
  trillion: {
    productName: "Trillion",
    monthlyProductId: "pro",
    yearlyProductId: "spikingpro",
    monthlyLabel: "$29 (1st month), then $299/year",
    yearlyLabel: "$299/year +",
    yearlyHighlightText: "1 month free",
    description:
      "Introductory offer for new subscribers only. $29 charged immediately for a 1-month paid trial. After your 1-month paid trial, $299 will be charged automatically for an annual subscription unless you cancel during your 1-month trial. Auto-renews as an annual subscription at the then current annual list price (current list price is $299/year).",
  },
  premium_subscription: {
    productName: "Premium",
    monthlyProductId: "premium",
    yearlyProductId: "spikingpremium",
    monthlyLabel: "$199 for 1st month, then $1,999/year",
    yearlyLabel: "$1,999/year +",
    yearlyHighlightText: "1 month free",
    description:
      "Introductory offer for new subscribers only. $199 charged immediately for a 1-month paid trial. After your 1-month paid trial, $1,999 will be charged automatically for an annual subscription unless you cancel during your 1-month trial. Auto-renews as an annual subscription at the then current annual list price (current list price is $1,999/year).",
  },
  "analysis-fiat": {
    productName: "Stocks FIAT Method",
    monthlyProductId: "fiat",
    yearlyProductId: "spikingfiat",
    monthlyLabel: "$29 (1st month), then $299/year",
    yearlyLabel: "$299/year +",
    yearlyHighlightText: "1 month free",
    description:
      "Introductory offer for new subscribers only. $29 charged immediately for a 1-month paid trial. After your 1-month paid trial, $299 will be charged automatically for an annual subscription unless you cancel during your 1-month trial. Auto-renews as an annual subscription at the then current annual list price (current list price is $299/year).",
  },
  ai: {
    productName: "SpikingAI®",
    monthlyProductId: "ai",
    yearlyProductId: "spikingai",
    monthlyLabel: "$39 (1st month), then $399/year",
    yearlyLabel: "$399/year +",
    yearlyHighlightText: "1 month free",
    description:
      "Introductory offer for new subscribers only. $39 charged immediately for a 1-month paid trial. After your 1-month paid trial, $399 will be charged automatically for an annual subscription unless you cancel during your 1-month trial. Auto-renews as an annual subscription at the then current annual list price (current list price is $399/year).",
  },
  "holy-grail": {
    productName: "Holy Grail Portfolios",
    monthlyProductId: "portfolios",
    yearlyProductId: "spikingportfolios",
    monthlyLabel: "$39 (1st month), then $399/year",
    yearlyLabel: "$399/year +",
    yearlyHighlightText: "1 month free",
    description:
      "Introductory offer for new subscribers only. $39 charged immediately for a 1-month paid trial. After your 1-month paid trial, $399 will be charged automatically for an annual subscription unless you cancel during your 1-month trial. Auto-renews as an annual subscription at the then current annual list price (current list price is $399/year).",
  },
  "insider-investors": {
    productName: "Insider Investors",
    monthlyProductId: "insider",
    yearlyProductId: "spikinginsider",
    monthlyLabel: "$79 (1st month), then $799/year",
    yearlyLabel: "$799/year +",
    yearlyHighlightText: "1 month free",
    description:
      "Introductory offer for new subscribers only. $79 charged immediately for a 1-month paid trial. After your 1-month paid trial, $799 will be charged automatically for an annual subscription unless you cancel during your 1-month trial. Auto-renews as an annual subscription at the then current annual list price (current list price is $799/year).",
  },
  "active-traders": {
    productName: "Active Traders",
    monthlyProductId: "active",
    yearlyProductId: "spikingactive",
    monthlyLabel: "$39 (1st month), then $399/year",
    yearlyLabel: "$399/year +",
    yearlyHighlightText: "1 month free",
    description:
      "Introductory offer for new subscribers only. $39 charged immediately for a 1-month paid trial. After your 1-month paid trial, $399 will be charged automatically for an annual subscription unless you cancel during your 1-month trial. Auto-renews as an annual subscription at the then current annual list price (current list price is $399/year).",
  },
  "top10-buysell": {
    productName: "Top 10 Buy/Sell",
    monthlyProductId: "top10buy",
    yearlyProductId: "top10buysell",
    monthlyLabel: "$29 (1st month), then $299/year",
    yearlyLabel: "$299/year +",
    yearlyHighlightText: "1 month free",
    description:
      "Introductory offer for new subscribers only. $29 charged immediately for a 1-month paid trial. After your 1-month paid trial, $299 will be charged automatically for an annual subscription unless you cancel during your 1-month trial. Auto-renews as an annual subscription at the then current annual list price (current list price is $299/year).",
  },
  "top30-ai-stocks": {
    productName: "Top 30 AI Stocks",
    monthlyProductId: "top30ai",
    yearlyProductId: "top30aistocks",
    monthlyLabel: "$29 (1st month), then $299/year",
    yearlyLabel: "$299/year +",
    yearlyHighlightText: "1 month free",
    description:
      "Introductory offer for new subscribers only. $29 charged immediately for a 1-month paid trial. After your 1-month paid trial, $299 will be charged automatically for an annual subscription unless you cancel during your 1-month trial. Auto-renews as an annual subscription at the then current annual list price (current list price is $299/year).",
  },
  "top200-sma": {
    productName: "Top 200 SMA",
    monthlyProductId: "top200sma",
    yearlyProductId: "spikingtop200sma",
    monthlyLabel: "$29 (1st month), then $299/year",
    yearlyLabel: "$299/year +",
    yearlyHighlightText: "1 month free",
    description:
      "Introductory offer for new subscribers only. $29 charged immediately for a 1-month paid trial. After your 1-month paid trial, $299 will be charged automatically for an annual subscription unless you cancel during your 1-month trial. Auto-renews as an annual subscription at the then current annual list price (current list price is $299/year).",
  },
  ytd: {
    productName: "YTD Stock Performance",
    monthlyProductId: "ytd",
    yearlyProductId: "spikingytd",
    monthlyLabel: "$29 (1st month), then $299/year",
    yearlyLabel: "$299/year +",
    yearlyHighlightText: "1 month free",
    description:
      "Introductory offer for new subscribers only. $29 charged immediately for a 1-month paid trial. After your 1-month paid trial, $299 will be charged automatically for an annual subscription unless you cancel during your 1-month trial. Auto-renews as an annual subscription at the then current annual list price (current list price is $299/year).",
  },
  // Courses - /upgrade-checkout/:alias links from /courses#cosy, #tttn, #special, #premium
  cosy: {
    productName: "COSY Live Trading",
    monthlyProductId: "cosy",
    yearlyProductId: "cosy20",
    monthlyLabel: "$199/class, then $2,999/20 classes",
    yearlyLabel: "$2,999/20 classes + 1 year Premium software",
    yearlyHighlightText: "",
    description:
      "$199 will be charged immediately for the upcoming COSY Live Trading Class. After your class, $2,999 will be charged automatically for 20 additional COSY Live Trading Classes unless you cancel.",
  },
  tttn: {
    productName: "Trade Through The Night",
    monthlyProductId: "tttn",
    yearlyProductId: "tttn4",
    monthlyLabel: "$299/class, then $999/4 classes",
    yearlyLabel: "$999/4 classes + 1 year Premium software",
    yearlyHighlightText: "",
    description:
      "$299 will be charged immediately for the upcoming TRADE THROUGH THE NIGHT Class. After your class, $999 will be charged automatically for 4 additional TRADE THROUGH THE NIGHT Classes unless you cancel.",
  },
  mars: {
    productName: "Mars Coaching",
    monthlyProductId: "coaching",
    yearlyProductId: "coaching12",
    monthlyLabel: "$299/class, then $2,999/12 classes",
    yearlyLabel: "$2,999/12 classes + 1 year Premium software",
    yearlyHighlightText: "",
    description:
      "$299 will be charged immediately for the upcoming MARS COACHING Class. After your class, $2,999 will be charged automatically for 12 additional MARS COACHING Classes unless you cancel.",
  },
  "premium-courses": {
    productName: "Premium Courses",
    monthlyProductId: "courses",
    yearlyProductId: "spikingcourses",
    monthlyLabel: "$29/1st month, then $299/year",
    yearlyLabel: "$299/year +",
    yearlyHighlightText: "1 month free",
    description:
      "Introductory offer for new subscribers only. $29 charged immediately for a 1-month paid trial. After your 1-month paid trial, $299 will be charged automatically for an annual subscription unless you cancel during your 1-month trial. Auto-renews as an annual subscription at the then current annual list price (current list price is $299/year).",
  },
};
